import { useCallback, useState } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';
import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { useStarterDashboardPageData } from 'src/app/pages/starterDashboard/pageContext';
import { shareCopy } from 'src/app/shared/share/copy';

const DEFAULT_TRACKING_DATA = { context: 'petition_dashboard', view_context: 'petitions_dashboard' };

const DEFAULT_TRACKING_EVENTS = { success: 'share_petition', failure: 'share_petition_failure' };

type UseCopyLinkButtonArgs = { shareUrl: string };
export function useCopyLinkButton({ shareUrl }: UseCopyLinkButtonArgs) {
	const {
		data: { petition, viewer },
	} = useStarterDashboardPageData();
	const utilityContext = useUtilityContext();
	const track = useTracking();

	const [copied, setCopied] = useState(false);
	const handleCopiedState = useCallback(() => {
		setCopied(true);
		setTimeout(() => {
			setCopied(false);
		}, 3000);
	}, []);

	const handleShare = useCallback(() => {
		const options = {
			trackingData: {
				...DEFAULT_TRACKING_DATA,
				petition_status: petition.status.toLowerCase(),
				own_petition: petition.user.id === viewer.user?.id,
				vanity_url: !!petition.starterVanityUrl,
			},
			trackingEvents: DEFAULT_TRACKING_EVENTS,
		};

		handleCopiedState();
		void shareCopy(shareUrl, options, track, utilityContext.i18n);
	}, [
		handleCopiedState,
		petition.starterVanityUrl,
		petition.status,
		petition.user.id,
		shareUrl,
		track,
		utilityContext.i18n,
		viewer.user?.id,
	]);

	return { data: { copied }, actions: { handleShare } };
}
